
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/uxui-improvement/page/[id]",
      function () {
        return require("private-next-pages/cases/uxui-improvement/page/[id].tsx");
      }
    ]);
  